
const NoSegmentAvailable = () => {
  console.debug('⚠️ No next segment available - no check-in needed');
  
  return (
    <div className="bg-travel-50 rounded-lg p-3 text-center text-travel-500">
      No trip details available
    </div>
  );
};

export default NoSegmentAvailable;
